import { createContext } from 'react';

export interface FullscreenLoadingContextType {
  /**
   * Signal that a fullscreen loading state is active. Increments an internal
   * ref count and returns a release function that decrements it. While the
   * count stays above zero, a single shared <Loading fullscreen /> instance
   * remains mounted — so its spinner animation never restarts as different
   * parts of the tree hand off loading to one another.
   */
  acquire: () => () => void;
}

export const FullscreenLoadingContext =
  createContext<FullscreenLoadingContextType | null>(null);
